import Config from './config';
import { noop, loadJs2, getOrCreateLocalId, getCookie } from './utils';

class XPReport {
  constructor (data, opts, uidFunc) {
    const options = opts || {};
    const env = options.env || 'prod';
    const config = Config[env];
    this.data = Object.assign({}, data);
    this.opts = Object.assign({}, config, options);
    this.uidFunc = uidFunc || noop;
    this.loading = false;
    this.uid = '';

    const isNode = typeof window === 'undefined' || typeof navigator === 'undefined';
    if (!isNode) {
      window.addEventListener('load', () => {
        this.init();
      }, false);
    }
  }

  init () {
    if (window.gdp || this.loading) {
      return;
    }
    this.loading = true;

    const opts = {
      debug: this.opts.debug || false,
      compress: this.opts.compress || false,
      hashtag: this.opts.hashtag || false,
      enableIdMapping: this.opts.enableIdMapping || false,
      host: this.opts.host,
      version: this.opts.version,
      autotrack: true,
    }
    if ('autotrack' in this.opts) {
      opts.autotrack = this.opts.autotrack;
    }
    if ('cookieDomain' in this.opts) {
      opts.cookieDomain = this.opts.cookieDomain;
    }
    if ('dataCollect' in this.opts) {
      opts.dataCollect = this.opts.dataCollect;
    }
    if ('ignoreFields' in this.opts) {
      opts.ignoreFields = this.opts.ignoreFields;
    }
    if ('scheme' in this.opts) {
      opts.scheme = this.opts.scheme;
    }

    const handleArr = [
      loadJs2('https://s.xiaopeng.com/xp-fe/js/report/gdp.umd.js')
    ];
    if (opts.autotrack) {
      handleArr.push(loadJs2('https://s.xiaopeng.com/xp-fe/js/report/plugins/umd/gioEventAutoTracking.js'));
    }
    if (opts.compress) {
      handleArr.push(loadJs2('https://s.xiaopeng.com/xp-fe/js/report/plugins/umd/gioCompress.js'));
    }
    Promise.all(handleArr)
      .then(() => {
        if (opts.autotrack && window.gioEventAutoTracking) {
          window.gdp('registerPlugins', [window.gioEventAutoTracking]);
        }
        if (opts.compress && window.gioCompress) {
          window.gdp('registerPlugins', [window.gioCompress]);
        }
        window.gdp('init', this.opts.accountId, this.opts.dataSourceId, opts);
        this.getUid().then(uid => {
          this.uid = uid || getCookie('wasxuid_r');
          if (this.uid) {
            gdp('setUserId', this.uid);
          }
        });
      })
      .catch(err => {
        console && console.warn && console.warn(err);
      })
      .then(() => this.loading = false);
  }

  getEventId (data) {
    if (data.eventId) {
      return data.eventId;
    }
    if (data.point) {
      return  `Web_${data.point.replace('`', '_')}`;
    }
    if (data.pageId && data.buttonId) {
      return  `Web_${data.pageId}_${data.buttonId}`;
    }
    if (data.default_eventId) {
      return data.default_eventId;
    }
    if (data.appid) {
      return  `Web_appid_${data.appid}`;
    }
    return  'Web_default_eventId';
  }

  getUid (uidFunc) {
    return new Promise((resolve) => {
      // 默认uid获取function
      uidFunc = uidFunc || this.uidFunc
      if (uidFunc && typeof uidFunc === 'function') {
        let uidFuncResult = uidFunc()
        // 支持promise函数
        if (uidFuncResult && uidFuncResult.then) {
          uidFuncResult
            .then(uid => resolve(uid))
            .catch(() => {
              resolve('');
              console && console.warn && console.warn('提供的uid获取函数，获取uid错误！')
            });
        } else {
          resolve(uidFuncResult);
        }
      } else {
        resolve('');
      }
    });
  }

  getPaObj (pa, _symbol) {
    // key=value`key=value
    const symbol = _symbol || '`';
    const arry = pa.split(symbol);
    const result = {};
    arry.forEach(item => {
      const data = item.split('=');
      if (data.length > 1) {
        result[data[0]] = data[1];
      }
    });
    return result;
  }

  sendData (data, options, uidFunc) {
    const opts = Object.assign({}, this.opts, options);

    const ls = getOrCreateLocalId();
    let properties = Object.assign({
      ls: ls, // 用户主键标识-前端
      nls: ls, // 兼容旧系统
      re: window.document.referrer, // 当前访问页面的url的referer
      url: window.location.href, // 当前访问页面的url
      type: 'page', // 兼容旧 sdk 加个默认值
    }, this.data, data);

    const eventId = this.getEventId(properties);
    delete properties.eventId;

    if (properties.point) {
      const point = properties.point.split('`');
      if (point.length > 1) {
        properties.pageId = point[0];
        properties.buttonId = point[1];
        // delete properties.point;
      }
    }

    if (properties.pa) {
      const paObj = this.getPaObj(properties.pa, opts.paSymbol);
      if ('type' in paObj) {
        paObj.pa_type = paObj.type;
        delete paObj.type;
      }
      properties = Object.assign({}, properties, paObj);
      // delete properties.pa;
    }

    this.getUid(uidFunc).then(uid => {
      properties.uid = uid || getCookie('wasxuid_r');
      if (this.uid !== properties.uid) {
        this.uid = properties.uid;
        if (this.uid) {
          gdp('setUserId', this.uid);
        }
      }
      // 发请求，上报数据
      window.gdp('track', eventId, properties);
    })
  }

  send (data, options, uidFunc) {
    if (window.gdp) {
      this.sendData(data, options, uidFunc)
    } else {
      this.init();
      setTimeout(() => {
        this.send(data, options, uidFunc);
      }, 1000);
    }
  }

  // 兼容以前的旧方法，不建议使用
  static getOrCreateLocalId () {
    return getOrCreateLocalId()
  }
}

export default XPReport
